/* SBI CUSTOM - bead strands bulk order page (sbi-bead-strands-bulk, 2026-10-18). Loaded with defer by sections/sbi-strands-bulk.liquid.
   Copied from assets/sbi-tumble-bulk.js (sbi-tumbled-stones-page). Rows are server-rendered (250 products per page; other pages
   are fetched with the Section Rendering API and merged). This adds: strand length / bead size / shape read from the titles,
   estimated beads per strand + price per bead (round/faceted beads only, "~"), filters, sort, ticks, steppers, +3/+5, and a
   dock that adds everything with ONE /cart/add.js call (items[]).
   Attribution: every line added here carries the hidden line-item property _bulk = <data-key> ("strands"); it is kept on the
   order line (Admin API lineItems.customAttributes) and counted by sbi-bead-strands-bulk/scripts/bulk_usage.py.
   URL presets: ?q=amethyst&mm=6mm&len=15&shape=chips&col=Purple&instock=1 */
(function () {
  var root = document.querySelector('[data-sb]');
  if (!root || root.__sb) return;
  root.__sb = true;

  var rowsWrap = root.querySelector('[data-sb-rows]');
  var rows = [];
  var dock = root.querySelector('[data-sb-dock]');
  var btnAll = root.querySelector('[data-sb-addall]');
  var selMm = root.querySelector('[data-sb-mm]'), selLen = root.querySelector('[data-sb-len]'), selCol = root.querySelector('[data-sb-col]');
  var state = { q: '', shape: 'all', mm: 'all', len: 'all', col: 'all', instock: false, out: false, sort: 'rank', tick: 1 };
  var KEY = 'sbiStrandsBulk';
  var BULK = root.getAttribute('data-key') || 'strands';
  var MM = 25.4;
  var SHAPES = { round: 'Round', faceted: 'Faceted', matte: 'Matte / frosted', electro: 'Electroplated', chips: 'Chips', barrel: 'Barrel', bundle: 'Bundles' };
  var SHAPE_ORDER = ['round', 'faceted', 'matte', 'electro', 'chips', 'barrel', 'bundle'];

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function store(v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY) || '{}'); sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return {}; } }
  function qtyInput(r) { return r.querySelector('[data-sb-qty]'); }
  function maxOf(r) { var m = parseInt(r.getAttribute('data-max'), 10); return isNaN(m) ? 99 : Math.max(0, m); }
  function A(r, k) { return r.getAttribute(k) || ''; }
  function num(x) { return parseFloat(String(x).replace(',', '.')); }

  /* --- strand spec from titles: length (inches), bead size (mm or a chip range), shape --- */
  function spec(vt, title, attrs) {
    var src = vt === 'Default Title' ? '' : vt;
    var all = [src, title, attrs];
    var len = null, lo = null, hi = null, m, i;
    for (i = 0; i < all.length && len === null; i++) {
      m = /(\d+(?:\.\d+)?)\s*(?:"|''|\u201d|inch)/i.exec(all[i] || '');
      if (m) len = num(m[1]);
    }
    for (i = 0; i < all.length && lo === null; i++) {
      var s = all[i] || '';
      m = /(\d+(?:\.\d+)?)\s*(?:mm)?\s*(?:-|to)\s*(\d+(?:\.\d+)?)\s*mm/i.exec(s);
      if (m) { lo = num(m[1]); hi = num(m[2]); break; }
      m = /(\d+(?:\.\d+)?)\s*mm/i.exec(s);
      if (m) { lo = hi = num(m[1]); }
    }
    var txt = (src || title) + ' ' + (attrs || '');
    var shape = 'round';
    if (/chip/i.test(txt)) shape = 'chips';
    else if (/barrel/i.test(txt)) shape = 'barrel';
    else if (/electroplat/i.test(src || title)) shape = 'electro';
    else if (/facet/i.test(src || title)) shape = 'faceted';
    else if (/matte|frosted/i.test(src || title)) shape = 'matte';
    var sizeKey = lo === null ? '' : (hi !== lo ? lo + '-' + hi + 'mm' : lo + 'mm');
    var beads = null;
    if (len && lo !== null && hi === lo && shape !== 'chips' && shape !== 'barrel' && lo > 0) beads = Math.floor(len * MM / lo);
    return { len: len, lo: lo, hi: hi, shape: shape, sizeKey: sizeKey, beads: beads };
  }

  /* readable size line: 15" strand \u00b7 6mm \u00b7 Faceted (keeps colour / Enhanced words from the variant title) */
  function sizeLine(sp, vt) {
    var parts = [];
    if (sp.len) parts.push(sp.len + '" strand');
    if (sp.sizeKey) parts.push(sp.sizeKey + (sp.shape === 'chips' ? ' chips' : ''));
    var rest = (vt === 'Default Title' ? '' : vt)
      .replace(/(\d+(?:\.\d+)?)\s*(?:"|''|\u201d)\s*-?\s*/, '')
      .replace(/(\d+(?:\.\d+)?)\s*(?:mm)?\s*(?:-|to)\s*(\d+(?:\.\d+)?)\s*mm/i, '')
      .replace(/(\d+(?:\.\d+)?)\s*mm/i, '')
      .replace(/\bchips?\b/i, '').replace(/^[\s\-]+|[\s\-]+$/g, '').replace(/\s{2,}/g, ' ');
    if (rest) parts.push(rest);
    else if (sp.shape !== 'chips') parts.push(SHAPES[sp.shape]);
    return parts.join(' \u00b7 ');
  }

  function prep(r) {
    if (r.__prep) return;
    r.__prep = true;
    var bundle = A(r, 'data-bundle') === '1';
    var sp = spec(A(r, 'data-vt'), A(r, 'data-t'), A(r, 'data-at'));
    r.setAttribute('data-shape', bundle ? 'bundle' : sp.shape);
    r.setAttribute('data-mm', bundle ? '' : sp.sizeKey);
    r.setAttribute('data-mmn', sp.lo === null ? '999' : String(sp.lo + (sp.hi - sp.lo) / 100));
    r.setAttribute('data-len', sp.len ? String(sp.len) : '');
    if (bundle) return;
    var sz = r.querySelector('[data-sb-size]');
    if (sz && (sp.len || sp.sizeKey)) sz.textContent = sizeLine(sp, A(r, 'data-vt'));
    var per = r.querySelector('[data-sb-per]'), bEl = r.querySelector('[data-sb-beads]');
    if (sp.beads) {
      var each = parseFloat(A(r, 'data-price')) / sp.beads;
      r.setAttribute('data-per', each.toFixed(3));
      if (bEl) bEl.textContent = '~' + sp.beads + ' beads per strand';
      if (per) per.innerHTML = '<b>~' + money(each) + '</b><span>per bead</span>';
    } else if (per) {
      per.innerHTML = '<small class="sbi-sb__muted">' + (sp.shape === 'chips' ? 'Chips, sold by length' : '-') + '</small>';
    }
  }

  function setQty(r, n, quiet) {
    var i = qtyInput(r); if (!i) return;
    var max = maxOf(r), q = Math.max(0, Math.min(isNaN(n) ? 0 : n, max));
    i.value = q;
    var t = r.querySelector('[data-sb-tick]'); if (t) t.checked = q > 0;
    r.classList.toggle('is-picked', q > 0);
    if (!quiet && n > max && max > 0) toast('Only ' + max + ' available for that one, so we set it to ' + max + '.', true);
    sum();
  }

  function sum() {
    var n = 0, styles = 0, total = 0, sel = {};
    rows.forEach(function (r) {
      var i = qtyInput(r); if (!i) return;
      var q = parseInt(i.value, 10) || 0;
      if (q > 0) { n += q; styles += 1; total += q * parseFloat(r.getAttribute('data-price')); sel[r.getAttribute('data-vid')] = q; }
    });
    root.querySelector('[data-sb-n]').textContent = n;
    root.querySelector('[data-sb-nlabel]').textContent = n === 1 ? 'strand' : 'strands';
    root.querySelector('[data-sb-styles]').textContent = styles;
    root.querySelector('[data-sb-total]').textContent = money(total);
    btnAll.disabled = n === 0;
    dock.classList.toggle('is-on', n > 0);
    dock.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
    /* the theme's back-to-top button (fixed, bottom centre, z-index 1300) sits on top of 'Add all to cart' on phones */
    document.documentElement.classList.toggle('sbi-sb-dock-on', n > 0);
    if (ready) store(sel);
  }

  /* sold-out sizes arrive as JSON (script[data-sb-o], one per product) and become rows only on request */
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function outCount() {
    var n = 0;
    root.querySelectorAll('script[data-sb-o]:not([data-done])').forEach(function (s) { try { n += (JSON.parse(s.textContent).v || []).length; } catch (e) {} });
    return n;
  }
  function buildOut() {
    var frag = document.createDocumentFragment(), box = document.createElement('div');
    root.querySelectorAll('script[data-sb-o]:not([data-done])').forEach(function (s) {
      s.setAttribute('data-done', '1');
      var d; try { d = JSON.parse(s.textContent); } catch (e) { return; }
      var P = d.p;
      (d.v || []).forEach(function (v) {
        box.innerHTML = '<div class="sbi-sb__r is-out' + (P.b ? ' is-bundle' : '') + '" role="row" data-row data-vid="' + v.v + '" data-rank="' + v.r + '" data-col="' + esc(P.c) +
          '" data-name="' + esc(P.n + ' ' + String(v.vt).toLowerCase()) + '" data-sort="' + esc(P.s) + '" data-price="' + v.pr + '" data-stock="0" data-max="0" data-instock="0" data-out="1" data-bundle="' + P.b +
          '" data-t="' + esc(P.t) + '" data-vt="' + esc(v.vt) + '"' + (P.a ? ' data-at="' + esc(P.a) + '"' : '') + (v.im ? ' data-img="' + esc(v.im) + '"' : '') + '>' +
          '<span role="cell" class="c-tick"></span><span role="cell" class="c-item"><a class="sbi-sb__img" href="' + esc(v.u) + '" tabindex="-1" aria-hidden="true"></a><span class="sbi-sb__txt"><a class="sbi-sb__name" href="' + esc(v.u) + '">' + esc(P.d) + '</a><span class="sbi-sb__size" data-sb-size>' + esc(v.z) + '</span><span class="sbi-sb__n" data-sb-beads></span></span></span>' +
          '<span role="cell" class="c-price">' + v.ph + '</span><span role="cell" class="c-per" data-sb-per></span><span role="cell" class="c-stock"><b class="s-out">Sold out</b></span><span role="cell" class="c-qty"><a class="sbi-sb__view" href="' + esc(v.u) + '">View</a></span></div>';
        frag.appendChild(box.firstChild);
      });
    });
    rowsWrap.appendChild(frag);
    rows = Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-row]'));
    rows.forEach(prep);
    sortRows();
  }

  /* sold-out rows ship without an <img> (page weight); add it the first time the row is shown */
  function showImg(r) {
    var a = r.querySelector('.sbi-sb__img'), src = r.getAttribute('data-img');
    r.removeAttribute('data-img');
    if (!a || !src || a.firstChild) return;
    var im = document.createElement('img');
    im.src = src; im.width = 80; im.height = 80; im.loading = 'lazy'; im.alt = '';
    a.appendChild(im);
  }

  function has(list, val) { return ('|' + list + '|').indexOf('|' + val + '|') > -1; }
  function apply() {
    var q = state.q.trim().toLowerCase(), shown = 0;
    rows.forEach(function (r) {
      var ok = true;
      if (q && A(r, 'data-name').indexOf(q) === -1) ok = false;
      if (ok && state.shape !== 'all' && A(r, 'data-shape') !== state.shape) ok = false;
      if (ok && state.mm !== 'all' && A(r, 'data-mm') !== state.mm) ok = false;
      if (ok && state.len !== 'all' && A(r, 'data-len') !== state.len) ok = false;
      if (ok && state.col !== 'all' && !has(A(r, 'data-col'), state.col)) ok = false;
      if (ok && state.instock && A(r, 'data-instock') !== '1') ok = false;
      if (ok && !state.out && A(r, 'data-out') === '1') ok = false;
      r.classList.toggle('is-hidden', !ok);
      if (ok) { shown += 1; if (r.hasAttribute('data-img')) showImg(r); }
    });
    var total = rows.filter(function (r) { return state.out || A(r, 'data-out') !== '1'; }).length;
    root.querySelector('[data-sb-shown]').innerHTML = shown + ' of ' + total + '<span class="sbi-sb__lg"> shown</span>';
    root.querySelector('[data-sb-empty]').hidden = shown !== 0 || !ready;
    var on = outCount(), ow = root.querySelector('[data-sb-outwrap]');
    if (ow) { ow.hidden = !ready || on === 0 || state.instock; root.querySelector('[data-sb-outn]').textContent = on; }
  }

  function sortRows() {
    var k = state.sort, s = rows.slice();
    var n = function (r, a, d) { var x = parseFloat(r.getAttribute(a)); return isNaN(x) ? d : x; };
    s.sort(function (a, b) {
      var rk = n(a, 'data-rank', 0) - n(b, 'data-rank', 0);
      if (k === 'name') return A(a, 'data-sort').localeCompare(A(b, 'data-sort')) || rk;
      if (k === 'price-asc') return n(a, 'data-price', 0) - n(b, 'data-price', 0) || rk;
      if (k === 'price-desc') return n(b, 'data-price', 0) - n(a, 'data-price', 0) || rk;
      if (k === 'bead') return n(a, 'data-per', 1e9) - n(b, 'data-per', 1e9) || rk;
      if (k === 'size') return n(a, 'data-mmn', 999) - n(b, 'data-mmn', 999) || n(a, 'data-len', 99) - n(b, 'data-len', 99) || rk;
      if (k === 'stock') return n(b, 'data-stock', 0) - n(a, 'data-stock', 0) || rk;
      return rk;
    });
    var frag = document.createDocumentFragment();
    s.forEach(function (r) { frag.appendChild(r); });
    rowsWrap.appendChild(frag);
  }

  /* dropdowns + shape chips are built from the rows, so they only offer values that exist */
  function fillSelect(sel, attr, keep, multi, order, label) {
    var seen = {};
    rows.forEach(function (r) { var v = A(r, attr); (multi ? v.split('|') : [v]).forEach(function (x) { if (x) seen[x] = 1; }); });
    var vals = Object.keys(seen).sort(order || function (a, b) { return a.localeCompare(b); });
    var first = sel.options[0];
    sel.innerHTML = '';
    sel.appendChild(first);
    vals.forEach(function (x) { var o = document.createElement('option'); o.value = x; o.textContent = label ? label(x) : x; sel.appendChild(o); });
    sel.value = vals.indexOf(keep) > -1 ? keep : 'all';
    sel.closest('label').hidden = vals.length === 0;
    return sel.value;
  }
  /* '3-5mm' before '3-10mm' before '4mm': lower bound, then upper bound */
  function byNum(a, b) {
    var x = a.match(/[\d.]+/g) || [0], y = b.match(/[\d.]+/g) || [0];
    return parseFloat(x[0]) - parseFloat(y[0]) || parseFloat(x[1] || x[0]) - parseFloat(y[1] || y[0]) || a.localeCompare(b);
  }
  function fillShapes() {
    var seen = {}, box = root.querySelector('[data-sb-shapes]');
    rows.forEach(function (r) { seen[A(r, 'data-shape')] = 1; });
    box.querySelectorAll('button:not([data-shape="all"])').forEach(function (b) { b.remove(); });
    SHAPE_ORDER.forEach(function (k) {
      if (!seen[k]) return;
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('data-shape', k); b.textContent = SHAPES[k];
      box.appendChild(b);
    });
    if (!seen[state.shape]) state.shape = 'all';
    pick('[data-sb-shapes]', 'data-shape', state.shape);
  }

  function pick(groupSel, attr, val) {
    root.querySelectorAll(groupSel + ' button').forEach(function (b) {
      var on = b.getAttribute(attr) === val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  var toastEl = root.querySelector('[data-sb-toast]');
  function toast(msg, err, cartLink) {
    toastEl.innerHTML = '';
    toastEl.appendChild(document.createTextNode(msg));
    if (cartLink) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View cart'; toastEl.appendChild(a); }
    toastEl.classList.toggle('is-err', !!err);
    toastEl.hidden = false;
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.hidden = true; }, err ? 6000 : 4500);
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-js-cart-count], [data-cart-count], .cart-count-bubble span').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload'));
    }).catch(function () {});
  }

  function post(items) {
    /* attribution: hidden line-item property, kept on the order line (see header comment) */
    items = items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: { _bulk: BULK } }; });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Could not add to cart'); e.status = r.status; throw e; } return j; }); });
  }

  /* --- events --- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('[data-shape]');
    if (b && b.tagName === 'BUTTON') { state.shape = b.getAttribute('data-shape'); pick('[data-sb-shapes]', 'data-shape', state.shape); apply(); return; }
    b = t.closest('[data-sb-tickqty] button');
    if (b) { state.tick = parseInt(b.getAttribute('data-n'), 10) || 1; pick('[data-sb-tickqty]', 'data-n', String(state.tick)); return; }
    var r = t.closest('[data-row]');
    if (r && t.closest('[data-sb-inc]')) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) + 1); return; }
    if (r && t.closest('[data-sb-dec]')) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) - 1, true); return; }
    b = t.closest('[data-sb-add]');
    if (r && b) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) + parseInt(b.getAttribute('data-sb-add'), 10)); return; }
    if (t.closest('[data-sb-showout]')) { state.out = true; buildOut(); apply(); return; }
    if (t.closest('[data-sb-reset]')) { reset(); return; }
    if (t.closest('[data-sb-clear]')) { rows.forEach(function (x) { setQty(x, 0, true); }); return; }
  });
  root.addEventListener('change', function (e) {
    var t = e.target, r = t.closest('[data-row]');
    if (t.matches('[data-sb-tick]') && r) { setQty(r, t.checked ? Math.max(parseInt(qtyInput(r).value, 10) || 0, state.tick) : 0); return; }
    if (t.matches('[data-sb-qty]') && r) { setQty(r, parseInt(t.value, 10) || 0); return; }
    if (t.matches('[data-sb-instock]')) { state.instock = t.checked; apply(); return; }
    if (t.matches('[data-sb-sort]')) { state.sort = t.value; sortRows(); return; }
    if (t === selMm) { state.mm = t.value; apply(); return; }
    if (t === selLen) { state.len = t.value; apply(); return; }
    if (t === selCol) { state.col = t.value; apply(); return; }
  });
  var qIn = root.querySelector('[data-sb-q]'), qT;
  qIn.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(function () { state.q = qIn.value; apply(); }, 120); });

  function reset() {
    state.q = ''; qIn.value = ''; state.shape = 'all'; state.mm = 'all'; state.len = 'all'; state.col = 'all'; state.instock = false;
    root.querySelector('[data-sb-instock]').checked = false;
    selMm.value = 'all'; selLen.value = 'all'; selCol.value = 'all';
    pick('[data-sb-shapes]', 'data-shape', 'all'); apply();
  }

  btnAll.addEventListener('click', function () {
    var items = [], picked = [];
    rows.forEach(function (r) {
      var i = qtyInput(r), q = i ? parseInt(i.value, 10) || 0 : 0;
      if (q > 0) { items.push({ id: +r.getAttribute('data-vid'), quantity: q }); picked.push(r); }
    });
    if (!items.length) return;
    btnAll.disabled = true; btnAll.textContent = 'Adding...';
    var total = items.reduce(function (a, b) { return a + b.quantity; }, 0);
    var done = function (added, failed) {
      btnAll.textContent = 'Add all to cart';
      picked.forEach(function (r) { if (failed.indexOf(r) === -1) setQty(r, 0, true); });
      refreshCart();
      if (failed.length) {
        toast('Added ' + added + ' strands. ' + failed.length + ' could not be added (stock changed); they are still ticked.', true, true);
      } else {
        toast('Added ' + added + ' strands to your cart.', false, true);
      }
      sum();
    };
    post(items).then(function () { done(total, []); }).catch(function () {
      /* one bad line rejects the whole call: fall back to one call per line so the rest still lands */
      var added = 0, failed = [], chain = Promise.resolve();
      items.forEach(function (it, k) {
        chain = chain.then(function () { return post([it]).then(function () { added += it.quantity; }).catch(function () { failed.push(picked[k]); }); });
      });
      chain.then(function () { done(added, failed); });
    });
  });

  /* --- start --- */
  var ready = false;
  var u = new URLSearchParams(location.search);
  if (u.get('q')) { state.q = u.get('q'); qIn.value = state.q; }
  if (u.get('shape')) state.shape = u.get('shape');
  if (u.get('mm')) state.mm = u.get('mm');
  if (u.get('len')) state.len = u.get('len');
  if (u.get('col')) state.col = u.get('col');
  if (u.get('instock') === '1') { state.instock = true; root.querySelector('[data-sb-instock]').checked = true; }

  function collect() {
    rows = Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-row]'));
    rows.forEach(prep);
    fillShapes();
    state.mm = fillSelect(selMm, 'data-mm', state.mm, false, byNum);
    state.len = fillSelect(selLen, 'data-len', state.len, false, byNum, function (x) { return x + '" strands'; });
    state.col = fillSelect(selCol, 'data-col', state.col, true);
  }
  function finish() {
    ready = true;
    var saved = store();
    rows.forEach(function (r) { var q = saved[r.getAttribute('data-vid')]; if (q) setQty(r, q, true); });
    sortRows(); apply(); sum();
  }

  collect(); sortRows(); apply(); sum();

  /* more than 250 products: fetch the other pages of this section and merge their rows */
  var pg = root.querySelector('[data-sb-pages]');
  var pages = pg ? parseInt(pg.getAttribute('data-sb-pages'), 10) || 1 : 1;
  var cur = pg ? parseInt(pg.getAttribute('data-sb-page'), 10) || 1 : 1;
  var sid = root.getAttribute('data-section');
  if (pages > 1 && sid && window.fetch) {
    var loading = root.querySelector('[data-sb-loading]');
    loading.hidden = false;
    var jobs = [];
    for (var k = 1; k <= pages; k++) {
      if (k === cur) continue;
      (function (n) {
        var url = location.pathname + '?page=' + n + '&section_id=' + encodeURIComponent(sid);
        jobs.push(fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var box = document.createElement('div');
          box.innerHTML = html;
          var got = box.querySelectorAll('[data-sb-rows] [data-row], [data-sb-rows] script[data-sb-o]');
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(got, function (r) { frag.appendChild(r); });
          rowsWrap.appendChild(frag);
        }).catch(function () {}));
      })(k);
    }
    Promise.all(jobs).then(function () {
      loading.hidden = true;
      var np = rowsWrap.querySelector('noscript'); if (np) np.remove();
      collect(); finish();
    });
  } else {
    finish();
  }
})();
